import {
  BKJIconTooltip,
  BKJPillDropdown,
  ErrorBoundary,
  Flex,
} from '@bookjane2/bookjane-design-library';
import i18next from 'i18next';
import {
  SecondaryLocationFilterDataProvider,
  useSecondaryLocationFilterDataContext,
} from 'modals/JaneDetailsModal/views/EditJaneView/SecondaryLocationFilterInput.context';
import {
  LabelText,
  TooltipWrapper,
} from 'modals/JaneDetailsModal/views/EditJaneView/EditJaneView.styled';
import { ChangeFunctionType } from '@bookjane2/bookjane-design-library/lib/common.types';
import { LocationOptionType } from 'components/LocationFilterInput/LocationFilterInput.types';

interface ISecondaryLocationSectionProps {
  onChange: ChangeFunctionType;
  dropdownName: string;
  dropdownValue: string[];
  dropdownTitle: string;
  dropdownTooltipInfo: string;
}

export const SecondaryLocationSectionComponent = (
  props: ISecondaryLocationSectionProps & {
    dropdownData: LocationOptionType[];
    hasNextPage: boolean;
    isLoading: boolean;
  },
) => {
  const {
    onChange,
    dropdownName,
    dropdownValue,
    dropdownTitle,
    dropdownTooltipInfo,
    dropdownData,
  } = props;

  return (
    <Flex flexDirection="column">
      <LabelText style={{ fontWeight: 'normal', fontFamily: 'Poppins Medium' }}>
        <Flex gap="8px">
          {dropdownTitle}
          <BKJIconTooltip iconName="Info" placement="top">
            <TooltipWrapper>{dropdownTooltipInfo}</TooltipWrapper>
          </BKJIconTooltip>
        </Flex>
      </LabelText>
      <BKJPillDropdown
        name={dropdownName}
        type="Multi"
        value={dropdownValue}
        onChange={onChange}
        options={dropdownData}
        max={20}
        validations={[]}
        placeholder={i18next.t('team_member:SELECT_SECONDARY_LOCATIONS')}
      />
    </Flex>
  );
};

const SecondaryLocationContainer = ({ ...rest }: ISecondaryLocationSectionProps) => {
  const { dropdownData, hasNextPage, isLoading } = useSecondaryLocationFilterDataContext();
  return (
    <SecondaryLocationSectionComponent
      {...rest}
      dropdownData={dropdownData}
      hasNextPage={hasNextPage}
      isLoading={isLoading}
    />
  );
};

export const SecondaryLocationSection = ({
  withEnabledFeatures,
  withoutEnabledFeatures = [],
  selectedPrimaryLocationId,
  ...rest
}: ISecondaryLocationSectionProps & {
  withEnabledFeatures: string[];
  withoutEnabledFeatures?: string[];
  selectedPrimaryLocationId?: string;
}) => {
  return (
    <ErrorBoundary componentName="SecondaryLocationSection">
      <SecondaryLocationFilterDataProvider
        withEnabledFeatures={withEnabledFeatures}
        withoutEnabledFeatures={withoutEnabledFeatures}
        selectedPrimaryLocationId={selectedPrimaryLocationId}
      >
        <SecondaryLocationContainer {...rest} />
      </SecondaryLocationFilterDataProvider>
    </ErrorBoundary>
  );
};
